import _ from 'lodash';
import {
  Modal,
  Form,
  Input,
  Select,
  Button,
  message,
  Spin,
  Radio,
} from 'antd';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

import * as actions from '../../../actions';

const FormItem = Form.Item;

class TriggerWebhooksModalComponent extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      triggerMode: 'single', // 'single' or 'bulk'
      bulkAccreditationIds: '',
      selectedWebhookIds: null,
      isLoading: false,
      // Constituent search fields
      constituentSearchType: 'id', // 'id' or 'external_id'
      constituentSearchValue: '',
      constituentAccreditations: [],
      selectedConstituentAccreditationId: null,
    };
  }

  componentDidMount() {
    // Don't fetch on mount - wait for user to search
  }

  handleBulkAccreditationIdsChange = e => {
    this.setState({ bulkAccreditationIds: e.target.value });
  };

  handleWebhookSelectionChange = value => {
    this.setState({
      selectedWebhookIds: value && value.length > 0 ? value : null,
    });
  };

  handleConstituentSearchTypeChange = e => {
    this.setState({ constituentSearchType: e.target.value });
  };

  handleConstituentSearchValueChange = e => {
    this.setState({ constituentSearchValue: e.target.value });
  };

  handleSearchConstituentAccreditations = () => {
    const { organizationId } = this.props;
    const { constituentSearchType, constituentSearchValue } = this.state;

    if (!organizationId) {
      message.error('Organization ID is required');
      return;
    }

    if (!constituentSearchValue.trim()) {
      message.error(
        `Please enter a constituent ${
          constituentSearchType === 'id' ? 'ID' : 'external ID'
        }`,
      );
      return;
    }

    this.setState({ isLoading: true });

    // Determine search parameter based on search type
    const constituentId = constituentSearchType === 'id'
      ? parseInt(constituentSearchValue.trim(), 10)
      : null;
    const constituentExternalId = constituentSearchType === 'external_id'
      ? constituentSearchValue.trim()
      : null;

    this.props
      .fetchAccreditationsByConstituent(
        organizationId,
        constituentId,
        constituentExternalId,
      )
      .then(action => {
        this.setState({ isLoading: false });
        console.log('Action object:', action);
        console.log('Action.data:', action.data);

        // Check if there are errors
        if (action.failed || (action.data && action.data._errors)) {
          const errorMessage = action.error
            ? action.error.message
            : 'Failed to fetch accreditations';
          message.error(errorMessage);
          this.setState({ constituentAccreditations: [] });
          return;
        }

        // Parse accreditations from response
        let accreditations = [];
        const responseData = action.data;

        console.log('Response data type:', typeof responseData);
        console.log('Is array:', Array.isArray(responseData));

        if (Array.isArray(responseData)) {
          accreditations = responseData;
        } else if (responseData && typeof responseData === 'object') {
          // Try different possible structure keys
          if (Array.isArray(responseData.data)) {
            accreditations = responseData.data;
          } else if (Array.isArray(responseData.items)) {
            accreditations = responseData.items;
          } else if (Array.isArray(responseData.accreditations)) {
            accreditations = responseData.accreditations;
          }
        }

        this.setState({ constituentAccreditations: accreditations });

        if (accreditations.length === 0) {
          message.warning('No accreditations found for this constituent');
        } else {
          message.success(
            `Found ${accreditations.length} accreditation(s) for this constituent`,
          );
        }
      })
      .catch(error => {
        this.setState({ isLoading: false });
        message.error('Failed to fetch accreditations for constituent');
        console.error(error);
        this.setState({ constituentAccreditations: [] });
      });
  };

  handleConstituentAccreditationSelect = value => {
    this.setState({ selectedConstituentAccreditationId: value });
  };

  handleTriggerClick = () => {
    const { organizationId } = this.props;
    const {
      triggerMode,
      bulkAccreditationIds,
      selectedWebhookIds,
      selectedConstituentAccreditationId,
    } = this.state;

    if (!organizationId) {
      message.error('Organization ID is required');
      return;
    }

    if (triggerMode === 'single') {
      const accreditationId = selectedConstituentAccreditationId;

      if (!accreditationId) {
        message.error('Please select an accreditation');
        return;
      }
      this.setState({ isLoading: true });
      this.props
        .triggerWebhook(accreditationId, organizationId, selectedWebhookIds)
        .then(action => {
          this.setState({ isLoading: false });
          if (action.data._errors) {
            Object.values(action.data._errors).forEach(errors => {
              errors.forEach(error => {
                message.error(<span>{error}</span>);
              });
            });
          } else {
            const { total_triggered, triggered_webhooks, errors } = action.data;
            message.success(
              `Successfully triggered ${total_triggered} webhook(s) for accreditation ${accreditationId}`,
            );
            if (errors && errors.length > 0) {
              errors.forEach(err => {
                message.warning(`Webhook ${err.webhook_id}: ${err.error}`);
              });
            }
            this.resetForm();
            this.props.onOk();
          }
        });
    } else if (triggerMode === 'bulk') {
      // Parse and validate accreditation IDs with better error handling
      const rawInput = bulkAccreditationIds.trim();

      if (!rawInput) {
        message.error('Please enter accreditation IDs');
        return;
      }

      // Split by common separators and remove empty strings
      const inputParts = rawInput
        .split(/[,\s;|\n\r]+/)
        .map(part => part.trim())
        .filter(part => part.length > 0);

      // Parse and validate each ID, tracking invalid entries
      const accredIds = [];
      const invalidEntries = [];

      inputParts.forEach(part => {
        const num = parseInt(part, 10);

        // Check if it's a valid positive integer
        if (Number.isNaN(num) || num <= 0 || !Number.isInteger(num) || part !== String(num)) {
          invalidEntries.push(part);
        } else {
          accredIds.push(num);
        }
      });

      // Show warning for invalid entries
      if (invalidEntries.length > 0) {
        const preview = invalidEntries.slice(0, 3).join(', ');
        const suffix = invalidEntries.length > 3 ? ` and ${invalidEntries.length - 3} more` : '';
        message.warning(
          `Ignored ${invalidEntries.length} invalid ID(s): ${preview}${suffix}`,
          5,
        );
      }

      this.setState({ isLoading: true });
      this.props
        .triggerWebhookBulk(accredIds, organizationId, selectedWebhookIds)
        .then(action => {
          this.setState({ isLoading: false });
          if (action.data._errors) {
            Object.values(action.data._errors).forEach(errors => {
              errors.forEach(error => {
                message.error(<span>{error}</span>);
              });
            });
          } else {
            const { total_triggered, triggered_webhooks, errors } = action.data;
            message.success(
              `Successfully triggered ${total_triggered} webhook event(s) for ${accredIds.length} accreditation(s)`,
            );
            if (errors && errors.length > 0) {
              errors.forEach(err => {
                message.warning(
                  `Accreditation ${err.accreditation_id}, Webhook ${err.webhook_id}: ${err.error}`,
                );
              });
            }
            this.resetForm();
            this.props.onOk();
          }
        });
    }
  };

  resetForm = () => {
    this.setState({
      bulkAccreditationIds: '',
      selectedWebhookIds: null,
      constituentSearchValue: '',
      constituentSearchType: 'id',
      constituentAccreditations: [],
      selectedConstituentAccreditationId: null,
    });
  };

  handleCancel = () => {
    this.resetForm();
    this.props.onCancel();
  };

  handleModeChange = e => {
    this.setState({ triggerMode: e.target.value });
  };

  getWebhookOptions = () => {
    const { fetchWebhooksItems } = this.props;
    if (!fetchWebhooksItems) return [];
    return fetchWebhooksItems.toJS().map(webhook => ({
      label: `${webhook.label} (${webhook.url})`,
      value: webhook.id,
    }));
  };

  renderSingleTab = () => {
    const { selectedWebhookIds } = this.state;
    const webhookOptions = this.getWebhookOptions();

    return (
      <div>
        {this.renderConstituentSearch()}

        <FormItem label="Webhooks (optional)">
          <Select
            mode="multiple"
            placeholder="Select specific webhooks or leave empty to trigger all active webhooks"
            options={webhookOptions}
            value={selectedWebhookIds || []}
            onChange={this.handleWebhookSelectionChange}
            allowClear
          />
        </FormItem>
        <p style={{ fontSize: '12px', color: '#666' }}>
          If no webhooks are selected, all active webhooks for the organization
          will be triggered.
        </p>
      </div>
    );
  };

  renderConstituentSearch = () => {
    const {
      constituentSearchType,
      constituentSearchValue,
      constituentAccreditations,
      selectedConstituentAccreditationId,
      isLoading,
    } = this.state;

    const accreditationOptions = constituentAccreditations.map(accred => ({
      label: `ID: ${accred.id} | Type: ${accred.type} | Status: ${accred.statusColor}`,
      value: accred.id,
    }));

    return (
      <div>
        <FormItem label={<span>Search by: <span style={{ color: 'red' }}>*</span></span>}>
          <Radio.Group
            value={constituentSearchType}
            onChange={this.handleConstituentSearchTypeChange}
            buttonStyle="solid"
            style={{
              display: 'flex',
              borderRadius: '20px',
              overflow: 'hidden',
              border: 'none',
              boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            }}
          >
            <Radio.Button
              value="id"
              style={{
                flex: 1,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                height: '38px',
                backgroundColor: constituentSearchType === 'id' ? '#e07856' : '#f0f0f0',
                color: constituentSearchType === 'id' ? 'white' : '#000',
                border: 'none',
                borderRadius: '20px 0 0 20px',
                fontWeight: constituentSearchType === 'id' ? '500' : '400',
                margin: 0,
                padding: 0,
                fontSize: '14px',
              }}
            >
              Constituent ID
            </Radio.Button>
            <Radio.Button
              value="external_id"
              style={{
                flex: 1,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                height: '38px',
                backgroundColor: constituentSearchType === 'external_id' ? '#2b7ba6' : '#f0f0f0',
                color: constituentSearchType === 'external_id' ? 'white' : '#000',
                border: 'none',
                borderRadius: '0 20px 20px 0',
                fontWeight: constituentSearchType === 'external_id' ? '500' : '400',
                margin: 0,
                padding: 0,
                fontSize: '14px',
              }}
            >
              External ID
            </Radio.Button>
          </Radio.Group>
        </FormItem>

        <FormItem
          label={<span>Constituent {constituentSearchType === 'id' ? 'ID' : 'External ID'} <span style={{ color: 'red' }}>*</span></span>}
        >
          <div style={{ display: 'flex', gap: '8px' }}>
            <Input
              placeholder={`Enter constituent ${
                constituentSearchType === 'id' ? 'ID' : 'external ID'
              }`}
              value={constituentSearchValue}
              onChange={this.handleConstituentSearchValueChange}
              onPressEnter={this.handleSearchConstituentAccreditations}
              disabled={isLoading}
            />
            <Button
              type="primary"
              onClick={this.handleSearchConstituentAccreditations}
              loading={isLoading}
            >
              Search
            </Button>
          </div>
        </FormItem>

        {constituentAccreditations.length > 0 && (
          <FormItem label={<span>Select Accreditation <span style={{ color: 'red' }}>*</span></span>}>
            <Select
              placeholder="Choose an accreditation from the search results..."
              value={selectedConstituentAccreditationId}
              onChange={this.handleConstituentAccreditationSelect}
              allowClear
            >
              {accreditationOptions.map(option => (
                <Select.Option key={option.value} value={option.value}>
                  {option.label}
                </Select.Option>
              ))}
            </Select>
          </FormItem>
        )}
        {constituentAccreditations.length === 0 && constituentSearchValue && (
          <p style={{ color: '#999', marginTop: '12px' }}>
            No accreditations available. Please search again.
          </p>
        )}
      </div>
    );
  };

  renderBulkTab = () => {
    const { bulkAccreditationIds, selectedWebhookIds } = this.state;
    const webhookOptions = this.getWebhookOptions();

    return (
      <div>
        <FormItem label={<span>Accreditation IDs <span style={{ color: 'red' }}>*</span></span>}>
          <Input.TextArea
            placeholder="Enter accreditation IDs separated by commas or whitespace&#10;Example: 123, 456, 789"
            value={bulkAccreditationIds}
            onChange={this.handleBulkAccreditationIdsChange}
            rows={4}
          />
        </FormItem>
        <FormItem label="Webhooks (optional)">
          <Select
            mode="multiple"
            placeholder="Select specific webhooks or leave empty to trigger all active webhooks"
            options={webhookOptions}
            value={selectedWebhookIds || []}
            onChange={this.handleWebhookSelectionChange}
            allowClear
          />
        </FormItem>
        <p style={{ fontSize: '12px', color: '#666' }}>
          If no webhooks are selected, all active webhooks for the organization
          will be triggered.
        </p>
      </div>
    );
  };

  render() {
    const { visible } = this.props;
    const { triggerMode, isLoading } = this.state;

    return (
      <Modal
        title="Trigger Webhooks"
        visible={visible}
        onCancel={this.handleCancel}
        width={600}
        footer={[
          <Button key="cancel" onClick={this.handleCancel}>
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            loading={isLoading}
            onClick={this.handleTriggerClick}
          >
            Trigger Webhooks
          </Button>,
        ]}
      >
        <Spin spinning={isLoading}>
          <div style={{ marginBottom: '20px' }}>
            <h4>Select trigger mode:</h4>
            <Radio.Group
              value={triggerMode}
              onChange={this.handleModeChange}
              disabled={isLoading}
              buttonStyle="solid"
              style={{
                display: 'flex',
                borderRadius: '20px',
                overflow: 'hidden',
                border: 'none',
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
              }}
            >
              <Radio.Button
                value="single"
                style={{
                  flex: 1,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  height: '38px',
                  backgroundColor: triggerMode === 'single' ? '#e07856' : '#f0f0f0',
                  color: triggerMode === 'single' ? 'white' : '#000',
                  border: 'none',
                  borderRadius: '20px 0 0 20px',
                  fontWeight: triggerMode === 'single' ? '500' : '400',
                  cursor: isLoading ? 'not-allowed' : 'pointer',
                  opacity: isLoading ? 0.6 : 1,
                  margin: 0,
                  padding: 0,
                  fontSize: '14px',
                }}
              >
                Single Accreditation
              </Radio.Button>
              <Radio.Button
                value="bulk"
                style={{
                  flex: 1,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  height: '38px',
                  backgroundColor: triggerMode === 'bulk' ? '#2b7ba6' : '#f0f0f0',
                  color: triggerMode === 'bulk' ? 'white' : '#000',
                  border: 'none',
                  borderRadius: '0 20px 20px 0',
                  fontWeight: triggerMode === 'bulk' ? '500' : '400',
                  cursor: isLoading ? 'not-allowed' : 'pointer',
                  opacity: isLoading ? 0.6 : 1,
                  margin: 0,
                  padding: 0,
                  fontSize: '14px',
                }}
              >
                Bulk (Multiple Accreditations)
              </Radio.Button>
            </Radio.Group>
          </div>

          <Form layout="vertical">
            {triggerMode === 'single'
              ? this.renderSingleTab()
              : this.renderBulkTab()}
          </Form>

          <div
            style={{
              marginTop: '20px',
              padding: '12px',
              backgroundColor: '#f0f2f5',
              borderRadius: '4px',
            }}
          >
            <h4 style={{ marginTop: 0 }}>Usage:</h4>
            <ul
              style={{ fontSize: '12px', margin: '8px 0', paddingLeft: '20px' }}
            >
              <li>Test newly configured webhooks</li>
              <li>Resend failed webhook notifications</li>
              <li>Trigger webhooks for accreditations updated externally</li>
              <li>Selectively trigger only specific webhooks</li>
            </ul>
          </div>
        </Spin>
      </Modal>
    );
  }
}

export const TriggerWebhooksModal = connect(
  state => ({
    organizationId: state.doc.getIn(
      ['authMr', 'constituent', 'organization', 'id'],
      null,
    ),
    fetchWebhooksItems: state.doc.getIn([
      'http',
      'fetchWebhooks',
      'data',
      'items',
    ]),
    searchAccreditationByIdItems: state.doc.getIn([
      'http',
      'searchAccreditationById',
      'data',
      'items',
    ]),
    searchAccreditationsInProgress: state.doc.getIn([
      'http',
      'searchAccreditationById',
      'inProgress',
    ]),
  }),
  actions,
)(TriggerWebhooksModalComponent);
